import { IBrandSummaryState } from 'state/new-summary/brand/brand.types'
import { BrandSummaryState } from 'state/new-summary/brand/brand.state'
import { BrandSummaryActions } from 'state/new-summary/brand/brand.actions'
import { Action } from '../../../infra/types'

export const BrandsReducer = (
  state: IBrandSummaryState = BrandSummaryState,
  action: Action<any>
): IBrandSummaryState => {
  switch (action.type) {
    case BrandSummaryActions.SET_LOADER: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          [action.payload.id]: action.payload.value
        }
      }
    }
    case BrandSummaryActions.RESET_PAGINATION_DATA: {
      return {
        ...state,
        page: 1,
        pageSize: 10,
        totalCount: Infinity
      }
    }
    case BrandSummaryActions.SET_BRAND_PRODUCT_MAPPING: {
      return {
        ...state,
        ...action.payload
      }
    }
    case BrandSummaryActions.SET_FILTER_DRAWER_TYPE: {
      return {
        ...state,
        filterDrawerType: action.payload.drawerType,
        dataList: action.payload.dataList,
        ...(action.payload.selectedDataKey && {
          filteredData: {
            ...state.filteredData,
            [action.payload.selectedDataKey]: action.payload.selectedDataValues
          }
        })
      }
    }
    case BrandSummaryActions.SET_FILTER_DATA_SUCCESS: {
      return {
        ...state,
        filteredData: {
          ...state.filteredData,
          [action.payload.selectedDataKey]: action.payload.selectedDataValues
        }
      }
    }
    case BrandSummaryActions.SET_PAGINATION_DATA: {
      return {
        ...state,
        ...action.payload
      }
    }
    case BrandSummaryActions.SET_DOWNLOAD_FILTERED_VIEW: {
      return {
        ...state,
        downloadFilteredView: action.payload
      }
    }
    case BrandSummaryActions.SET_BRAND_SALE_ACTIVE_FILTER: {
      return {
        ...state,
        activeFilter: action.payload
      }
    }
    // case BrandSummaryActions.SET_DRAWER: {
    //   return {
    //     ...state,
    //     drawers: {
    //       ...state.drawers,
    //       [action.payload.modalName]: action.payload.status
    //     }
    //   }
    // }
    case BrandSummaryActions.FETCH_BRAND_SUMMARY_DATA_SUCCESS: {
      return {
        ...state,
        brandSaleSummary: action.payload
      }
    }
    case BrandSummaryActions.FETCH_BRAND_SUMMARY_DATA: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          outerGroupSummary: true
        }
      }
    }
    case BrandSummaryActions.FETCH_BRAND_REPORT: {
      return {
        ...state,
        loaders: {
          ...state.loaders,
          innerSummaryItems: true
        }
      }
    }
    case BrandSummaryActions.FETCH_BRAND_REPORT_SUCCESS: {
      return {
        ...state,
        brandReportItems: action.payload
      }
    }
    case BrandSummaryActions.SET_OVERALL_BRAND_SUMMARY: {
      return {
        ...state,
        brandOverallSaleSummary: action.payload
      }
    }
    default: {
      return state
    }
  }
}
